<template>
    <v-form ref="companyNameForm">
        <company-name-fields :initialValue="formData" @update="syncFormData" @validityChanged="syncFormValidity"></company-name-fields>

        <!--Only show cancel if text is set. Always show submit, but only enable it if the form is valid-->
        <v-btn v-if="cancelButtonText" @click="raiseCancel" flat color="error">{{cancelButtonText}}</v-btn>
        <v-btn @click="submit" :disabled="!formValid">{{submitButtonText}}</v-btn>
    </v-form>
</template>

<script>
  import {FormMixin, BasicFormSyncMixin} from '@/forms/mixins'
  import CompanyNameFields from '@/forms/company/CompanyNameFields'

  export default {
    name: 'CompanyNameForm',
    mixins: [FormMixin, BasicFormSyncMixin],
    components: {CompanyNameFields},
    props: {
      initialValue: {}
    },
    data: () => ({
      // Notice how we set formData to null? This is because the form itself only has a single field, so the data is not
      // and object. We also just pass the formData value, rather than a nested property. Just something to watch out
      // for.
      formData: null,
    })
  }
</script>

<style scoped>

</style>
